/**
 * WordPress dependencies.
 */
import { __ } from '@wordpress/i18n';
import { PanelBody, SelectControl, ToggleControl } from '@wordpress/components';

import { GroupControl } from '@vayu-blocks';

const BlurbSettingPanel = ({
            attributes,
            setAttributes,
			openPanels, 
			onTogglePanel
        }) => {
    return (
        
        <PanelBody title={ __( 'Blurb', 'vayu-blocks' ) }
        opened={openPanels['vb-blurb-set']} onToggle={() => onTogglePanel('vb-blurb-set')} 
        >

            <SelectControl
                    label={ __( 'Blurb Layout', 'vayu-blocks' ) }
                    value={ attributes.blurbLayout }
                    options={ [
                        { label:  __( 'Classic', 'vayu-blocks' ), value: 'classic' },
                        { label: __( 'Flipbox', 'vayu-blocks' ), value: 'flipbox' },
                        
                    ] }
                    onChange={ e => setAttributes({ blurbLayout: e }) }
        />

                 <ToggleControl
                    label={ __( 'Enable Link', 'vayu-blocks' ) }
                    checked={ attributes.linkEnable }
                    onChange={ linkEnable => setAttributes({ linkEnable }) }
                />

  {(attributes.blurbLayout == 'classic') && (			
  <>
  <h4>{__('Choose Classic Layout', 'vayu-blocks')}</h4>
    <GroupControl
        label={__('Choose Classic Layout', 'vayu-blocks')}
        value={ attributes.chooseLayoutClassic}
        onChange={ e => setAttributes({chooseLayoutClassic : e }) }		
        options={[
            {
                
                label: __( 'Style 1', 'vayu-blocks' ),
                value: 'classic1'
            },
            {
                
                label: __( 'Style 2', 'vayu-blocks' ),
                value: 'classic2'
            }
        ]}
        hasIcon = {false}
      /> 
    </> 
   )}	
   {(attributes.blurbLayout == 'flipbox') && (			
  <>
  <h4>{__('Choose Flipbox Layout', 'vayu-blocks')}</h4>
    <GroupControl
        label={__('Choose flipBox Layout', 'vayu-blocks')}
        value={ attributes.chooseLayoutFlipbox}
        onChange={ e => setAttributes({chooseLayoutFlipbox : e }) }		
        options={[
            {
                
                label: __( 'Style 1', 'vayu-blocks' ),
                value: 'flipbox1'
            },
            {
                
                label: __( 'Style 2', 'vayu-blocks' ),
                value: 'flipbox2'
            }
        ]}
        hasIcon = {false}
      /> 
    </> 
   )}
</PanelBody>
)

}
export default BlurbSettingPanel;